import OnlineLayout from '@/pages/online/layout'
import OnlineIndexPage from '@/pages/online/index'
import OnlineViewLayout from '@/pages/online/viewTabs/layout'
import OnlineViewIndexPage from '@/pages/online/viewTabs/index'
// import OnlineViewMemberPage from '@/pages/online/viewTabs/member.vue'
import ProductViewMemberPage from '@/pages/product/viewTabs/member.vue'
// update
import OnlineUpdateIndexPage from '@/pages/online/updateTabs/index'

var routes = {
	path: '/online',
	component: OnlineLayout,
	meta: {title: 'Онлайн-обучение', breadcrumb: 'Онлайн-обучение'},
	children: [
		{
			path: '',
			component: OnlineIndexPage,
			meta: {title: 'Продукты'}
		}, {
			path: ':id',
			component: OnlineViewLayout,
			children: [
				{
					path: 'update',
					component: OnlineUpdateIndexPage,
					meta: {title: 'Редактирование онлайн-продукта'}
				}, {
					path: 'view',
					component: OnlineViewIndexPage,
					meta: {title: 'Информация | Онлайн-обучение'}
				}, {
					path: 'members',
					component: ProductViewMemberPage,
					meta: {title: 'Участники | Онлайн-обучение'}
				}
			]
		}
	]
}
export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/online.js